"use strict";
// Copyright © 2021 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.FALLBACK_IMG_BASE64 = void 0;
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
exports.FALLBACK_IMG_BASE64 = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';
//# sourceMappingURL=Image.config.js.map